<template>
    <div class="index flex jc-sb flex-c">
        <div v-if="$route.name !== 'home' " :style="`height:${scale_ratio<1?43:72}px;`"></div>
        <div class="flex pr flex-item flex-c zi-1">
            <router-view ref="child" />
        </div>
        <div :class="'footer pd-t-44 '"  >
            <div :class="scale_ratio < 1 ? 'mr-h-30' : 'mr-h-100'">
                <div :class="'pd-b-44 '+ (scale_ratio < 1 ? 'pd-b-20 oh' : 'flex jc-sa ') ">
                    <div :class="scale_ratio < 1 ? 'mr-b-20 auto' : ' of-ct'" :style="scale_ratio < 1 ?'max-width: 50%;':'width:150px;'">
                        <img :src=" system_data.logo|img " alt=""
                             class="dis-block wh-auto of-ct "
                        />
                    </div>
                    <div class="cr-white-t lh-20 txt-size-13" :class="scale_ratio < 1 ? 'mr-b-20 ' : 'w-min-180 w-max-300 '" >
                        <div class="icon flex al-c pd-b-5">
                            <img :src="require('@/assets/images/bot-icon-1.png')" alt="" style="width: 20px" />
                            <span class="txt-size-20 lh-30 fw-b mr-l-10 cr-white">地址</span>
                        </div>
                        <div class="mr-t-10" v-for="(item) in system_data.address">{{item}}</div>
                    </div>
                    <div class="cr-white-t lh-20 txt-size-13" :class="scale_ratio < 1 ? 'mr-b-20 ' : 'w-min-180 w-max-300 '" >
                        <div class="icon flex al-c  pd-b-5">
                            <img :src="require('@/assets/images/bot-icon-2.png')" style="width: 20px" alt="" />
                            <span class="txt-size-20 lh-30 fw-b mr-l-10 cr-white">联系方式</span>
                        </div>
                        <div class="oh mr-t-15">
                            <div class="mr-b-10 pr pd-l-60">
                                <div class="pa-lt tj-one" style="width: 60px;">联系人：</div>
                                <div v-html="get_text_html(system_data.brandManager,0)"></div>
                            </div>
                            <div class="mr-b-10  pr pd-l-60">
                                <div class="pa-lt tj-one" style="width: 60px;">电<i class="mr-h-5 dis-inline-block "></i>话：</div>
                                <div v-html="get_text_html(system_data.phone,0)"></div>
                            </div>
                            <div class="pr pd-l-60">
                                <div class="pa-lt tj-one" style="width: 60px;">邮<i class="mr-h-5 dis-inline-block"></i>箱：</div>
                                <div v-html="get_text_html(system_data.email,0)"></div>
                            </div>
                        </div>
                    </div>
                    <div class="cr-white-t lh-20 txt-size-13" :class="scale_ratio < 1 ? '' : 'w-min-180 w-max-300 '"  >
                        <div class="icon flex al-c  pd-b-5">
                            <img :src="require('@/assets/images/bot-icon-3.png')" style="width: 20px" alt="" />
                            <span class="txt-size-20 lh-30 fw-b mr-l-10 cr-white">社交媒体</span>
                        </div>
                        <div class="pr pd-l-60">
                            <div class="pa-lt tj-one" style="width: 60px;">网<i class="mr-h-5 dis-inline-block"></i>址：</div>
                            <div v-html="get_text_html(system_data.socialMediaUrl,0)"></div>
                        </div>
                        <div class="mr-t-15 tc dis-inline-block" v-if="system_data.socialMedia&&system_data.socialMedia.length > 0">
                            <img :src="$static_url+system_data.socialMedia[0].path" class="rect-80" alt="" />
                            <div class="mr-t-5">官方公众号</div>
                        </div>
                    </div>
                </div>
                <div class="pd-v-20 lh-20 br-t tc  bot-border">
                    <a href="https://beian.miit.gov.cn/" class="txt-hover " target="_blank" >{{ system_data.beian }}</a>
                    <a class="mr-l-20 ">访问次数：{{visits}}</a>
                </div>
            </div>
        </div>

        <!--返回顶部按钮-->
        <!--<div class="rect-60 br-rad-6 pf flex al-c jc-c cr-white txt-size-24 bg-primary zi-99" style="bottom:30px;right: 30px;" @click="back_top()">-->
        <!--    <Icon type="md-arrow-round-up" />-->
        <!--</div>-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            show_QR_code: false,
            visits:0,
        };
    },
    computed: {
        ...mapGetters(['system_data']),
        scale_ratio: function () {
            return Number(this.$store.state.system.scale_ratio);
        },
    },
    created() {
        this.get_data()
        this.set_scale();
        this.set_visits_add();
        window.addEventListener('resize', this.set_scale); //浏览器窗口大小计算比例
    },
    mounted() {},
    methods: {
        /**
         *@Description 访问次数加1
         *@author liujiaji
         */
        set_visits_add(){
            this.$api.post('home/updateHomeVisitNum',{}).then(res=>{
                this.get_visits();
            }).catch(()=>{
                this.get_visits();
            })
        },
        /**
         *@Description 查询访问量
         *@author liujiaji
         */
        get_visits(){
            this.$api.post('home/getHomeVisitNum',{}).then(res=>{
                if (res.status === 200){
                    this.visits = res.data||0;
                }
            })
        },
        //获取页脚信息
        get_data(){
            const params = {}
            this.$api.post('/page/getHomePageInfo',params).then(res=>{
                if (res.status === 200) {
                    const data = res.data;
                    this.$store.commit('set_system_data', {
                        address:data.addres,
                        brandManager:data.brandManager,
                        phone:data.phone,
                        email:data.email,
                        socialMediaUrl:data.socialMediaUrl,
                        socialMedia:data.socialMedia,
                        logo:data.logoImageList,
                        beian:data.beian||'备案号'
                    });
                }
            })
        },
        set_scale() {
            var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
            if (bodyWidth < 1300) {
                const value = bodyWidth / 1300;
                this.$store.commit('set_scale_ratio', value.toFixed(2));
            } else {
                this.$store.commit('set_scale_ratio', 1);
            }
            if (bodyWidth <= 750) {
                this.$store.commit('set_scale_mob', true);
            } else {
                this.$store.commit('set_scale_mob', false);
            }
        },
        /**
         *@name 返回頂部
         *@author liujiaji
         */
        // back_top() {
        //     let _wrapper = document.getElementById('app');
        //     let wrapperY = _wrapper.scrollTop;
        //     const move_num = _wrapper.scrollTop > 1000 ? _wrapper.scrollTop / 200 : 10; //每5毫秒移动的距离，共耗时1秒
        //     let timer = setInterval(function () {
        //         if (wrapperY <= 0) {
        //             clearInterval(timer);
        //         }
        //         wrapperY -= move_num;
        //         _wrapper.scrollTop = wrapperY;
        //     }, 5);
        // },
    },
};
</script>

<style lang="less" scoped>
@import 'index';
</style>
